/**
 * @file The Insight Leave component
 * @author Maarten Lensink
*/
import * as tslib_1 from "tslib";
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { DomainService } from '../../domain.service';
import { ResourceService } from '../../resource.service';
import { addZero } from '../../base/helpers/addZero';
import { ComponentRegistry } from '../../core/component-registry';
import { LocalisationService } from '../../core/localisation.service';
import { InsightProvider } from '../insight-provider';
import { InsightService } from '../insight.service';
import { InsightTableComponent } from '../insight-table/insight-table.component';
import { EntityQuery } from 'breeze-client';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
var InsightLeaveComponent = /** @class */ (function (_super) {
    tslib_1.__extends(InsightLeaveComponent, _super);
    /**
     * Creates an instance of InsightLeaveComponent.
     * @param {ResourceService} resourceService
     * @param {InsightProvider} provider
     * @param {InsightService} insightService
     * @param {LocalisationService} localisationService
     * @param {Router} router
     * @param {DomainService} domainService
     * @memberOf InsightLeaveComponent
     */
    function InsightLeaveComponent(resourceService, provider, insightService, localisationService, router, domainService, translateService, alertsService, eventsService) {
        var _this = _super.call(this, resourceService, provider, insightService, localisationService, alertsService, eventsService) || this;
        _this.translateService = translateService;
        _this.alertsService = alertsService;
        /**
         * The horizon date.
         * @protected
         * @memberOf InsightLeaveComponent
         */
        _this.horizonDate = moment().startOf('day');
        _this.makeHorizonDateListener(_this.subscriptionPool, router, function (value) {
            _this.horizonDate = value;
            // Allow main view to refresh first. Insights are of lesser importance.
            window.setTimeout(function () {
                _this.refresh();
            }, 2000);
        });
        _this.makeEntityChangedListener(_this.subscriptionPool, domainService, function (data) {
            if (data.entity.entityType.shortName === 'Appointment') {
                _this.refresh();
            }
        });
        return _this;
    }
    Object.defineProperty(InsightLeaveComponent.prototype, "start", {
        /**
         * Returns the start of the horizon year.
         * @readonly
         * @type {Date}
         * @memberOf InsightLeaveComponent
         */
        get: function () {
            var start = this.horizonDate.clone().startOf('year');
            return start.toDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightLeaveComponent.prototype, "finish", {
        /**
         * Returns the end of the horizon year.
         * @readonly
         * @type {Date}
         * @memberOf InsightLeaveComponent
         */
        get: function () {
            var finish = this.horizonDate.clone().endOf('year');
            return finish.toDate();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Registers the insight component.
     * @static
     * @memberOf InsightLeaveComponent
     */
    InsightLeaveComponent.register = function () {
        ComponentRegistry.register('insight', 'InsightLeaveComponent', InsightLeaveComponent);
    };
    /**
     * Displays the loaded data.
     * @memberOf InsightLeaveComponent
     */
    InsightLeaveComponent.prototype.afterItemsLoaded = function () {
        var _this = this;
        this.data.footerKey = this.horizonDate.year().toString();
        var used = moment.duration();
        this.loadedItems.forEach(function (item) {
            // For some reason item.value is a string.
            var value = Number.parseFloat(item['value']);
            used.add(value, 'hours');
        });
        var query = new EntityQuery('InsightSingleValueDouble');
        query.parameters = {
            oid: this.resourceService.getResourceOid(),
            table: 'Resources',
            property: 'UDF_Verlofuren'
        };
        this.insightService.entityManager.executeQuery(query).then(function (response) {
            // The result set is an array of numbers (with one element), but Breeze expects Entity objects.
            var value = response.results[0];
            var total = moment.duration(value, 'hours');
            _this.setData([{
                    name: _this.translateService.instant('APP.INSIGHTS.LEAVE_HOURS'),
                    value: _this.durationToString(total)
                }, {
                    name: _this.translateService.instant('APP.INSIGHTS.LEAVE_TAKEN'),
                    value: _this.durationToString(used)
                }, {
                    name: _this.translateService.instant('APP.INSIGHTS.BALANCE'),
                    value: _this.durationToString(total.subtract(used))
                }]);
        });
    };
    /**
     * Returns the string representation of a duration.
     * @private
     * @param {moment.Duration} value The calculated duration
     * @returns {string} The hours and minutes as string
     * @memberOf InsightLeaveComponent
     */
    InsightLeaveComponent.prototype.durationToString = function (value) {
        var hours = Math.floor(value.asHours());
        var result = hours + ':' + addZero(value.minutes());
        return result;
    };
    return InsightLeaveComponent;
}(InsightTableComponent));
export { InsightLeaveComponent };
